import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ScheduleIcon from '@mui/icons-material/Schedule';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AlarmOffIcon from '@mui/icons-material/AlarmOff';

const options = {
    file_type: [
        { value: 'csv', label: 'Comma Separated Values (CSV)' },
        { value: 'txt', label: 'Tab-Delimited File (TXT)' },
        { value: 'json', label: 'JavaScript Object Notation (JSON)' }
    ],
    actions: [
        { value: 'POST', label: 'Add', icon: <AddIcon /> },
        { value: 'DELETE', label: 'Delete', icon: <ClearIcon /> },
        { value: 'PUT', label: 'Update', icon: <ArrowUpwardIcon /> }
    ],
    actionsGoogle: [
        { value: 'insert', label: 'Add', icon: <AddIcon /> },
        { value: 'delete', label: 'Delete', icon: <ClearIcon /> },
        { value: 'update', label: 'Update', icon: <ArrowUpwardIcon /> }
    ],
    qualtricsSurveyTypes: [
        { value: 'Student', label: 'Student' },
        { value: 'Staff', label: 'Staff' },
        { value: 'Other', label: 'Other' }
    ],
    noHeaders: [
        { value: true, label: 'True' }
    ],
    operator: [
        { value: 'lt', label: '<' },
        { value: 'le', label: '<=' },
        { value: 'eq', label: '=' },
        { value: 'ge', label: '>=' },
        { value: 'gt', label: '>' },
        { value: 'co', label: 'contains' }
    ],
    orientation: [
        { value: 'Portrait', label: 'Portrait'},
        { value: 'Landscape', label: 'Landscape'}
    ],
    frequency: [
        { value: 'daily', label: 'Daily', icon: <ScheduleIcon /> },
        { value: 'hourly', label: 'Hourly', icon: <MoreTimeIcon />, frozen: "hour", inputProps: {min: "00:00", max: "00:59"} },
        { value: '12hrmf', label: '12-Hour (M-F)', icon: <AlarmOffIcon />, frozen: "hour", inputProps: {min: "00:00", max: "00:59"} },
        { value: 'custom', label: 'Custom', icon: <AutoAwesomeIcon /> }
    ]
}

export default options;